import {enableDemo} from "../env";

function getDemoFromUrl() {
    const url = window.location.href;

    return enableDemo && url.includes("demo");

}

export default getDemoFromUrl;
